import type { IComponentController, IScope } from "angular";

import type { SearchResultType } from "App/Modules/Models";
import type { ISearchRepository } from "App/Modules/Repositories";
import type { IFormContainerResolve } from "App/Modules/Services";

export class ExtendedSearchDetailsComponentController implements IComponentController {
    public static $inject: string[] = ["$scope", "mmSearchRepository"];

    public resolve: IFormContainerResolve<
        string,
        {
            type: SearchResultType;
            caption: string;
            typingOffset: number;
        }
    >;

    public searchString: string;

    public type: SearchResultType;

    public caption: string;

    public typingOffset: number;

    constructor(private readonly $scope: IScope, private readonly searchRepository: ISearchRepository) {}

    public $onInit() {
        this.searchString = this.resolve.formData;
        this.type = this.resolve.bindings.type;
        this.caption = this.resolve.bindings.caption;
        this.typingOffset = this.resolve.bindings.typingOffset;
    }

    public returnToSearchOverview() {
        this.resolve.options.onCancel();
    }
}
